export const getDashboardMenuItems = (handleLogout: () => void, isPending: boolean) => [
  {
    id: "22",
    iconSrc: "/assets/svg/profileIcons/userAcc.svg",
    text: "حساب کاربری",
    link: '/dashboard',
  },
  {
    id: "23",
    iconSrc: "/assets/svg/profileIcons/marked.svg",
    text: "علاقه‌مندی‌های من",
    link: "/dashboard/favorites",
  },
  {
    id: "24",
    iconSrc: "/assets/svg/profileIcons/ads.svg",
    text: "آگهی‌های من",
    link: "/dashboard/my-ads",
  },
  {
    id: "25",
    iconSrc: "/assets/svg/profileIcons/file-01.svg",
    text: "درخواست‌های من",
    link: "/dashboard/my-requests",
  },
  {
    id: "26",
    iconSrc: "/assets/svg/profileIcons/logout-03.svg",
    text: "خروج",
    func: handleLogout,
    disabled: isPending,
  },
];
